// extracted by mini-css-extract-plugin
export default {"container":"formats_container__2QlbO","title":"formats_title__3IOeu","item":"formats_item__2PXV3","format":"formats_format___rj8-"};